/**
 * this function looks to remove a single url parameter from a qs string
 * @param ctaGlinkUrl
 * @param parameter
 * @returns {string}
 */
const removeURLParameter = (ctaGlinkUrl, parameter) => {
  const url = new URL(ctaGlinkUrl);
  const params = url.searchParams;
  params.delete(parameter);
  url.search = params.toString();
  return url.toString();
};

/**
 * adds eventListener on search form submit, updates url with new search string
 * and redirects to new url
 * @returns {string}
 */
const searchFormSubmitAction = () => {
  const ctaGlink = document.querySelector('.citem1 .cta-block__item');
  const organicgSearchForm = document.querySelector('#organicgSearch');
  if (ctaGlink && organicgSearchForm) {
    const ctaGlinkUrl = removeURLParameter(ctaGlink.href, 'p');
    organicgSearchForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const formData = new FormData(organicgSearchForm);
      const searchText = formData.get('p').trim();
      if (searchText) {
        formData.set('p', searchText);
        const queryString = new URLSearchParams(formData).toString();
        const finalUrl = `${ctaGlinkUrl}&${queryString}`;
        window.location.href = finalUrl;
      }
    });
  }
};

/**
 * serp Obj
 */
const serp = () => {
  searchFormSubmitAction();
};

export default serp;
